@if (dataService.dataLoaded()) {
  <ces-asset-breadcrumb [trail]="breadcrumbTrail()" />
}
<div class="p-(--padding-card) pt-(--space-2)">
  @if (!dataService.dataLoaded()) {
    <app-measure-skeleton />
  } @else if (!measure()) {
    <div class="p-(--padding-card) text-center bg-orange-100 border border-orange-300 rounded-(--radius-md) mb-(--space-4)">
      <p>{{ 'entities.measure.messages.noSelection' | transloco }}</p>
    </div>
  } @else {
    @if (measure(); as currentMeasure) {
      <div class="mb-(--space-4) flex justify-between items-center">
        <div class="flex flex-col items-start">
          <h2 class="text-h1">{{ currentMeasure.name }}</h2>
          <span class="text-sm text-(color:--text-secondary)"
            >{{ dataService.measureType()?.name || currentMeasure.measureTypeId }} ({{
              dataService.unit()?.name || currentMeasure.unitId
            }})</span
          >
          <p-tag class="mt-(--space-2)" [value]="kindLabelKey | transloco" severity="info" />
        </div>

        <div class="flex gap-(--gap-normal)">
          <ces-menu-button-secondary
            [hasPermission]="{ method: 'deleteMeasureDetailResource', assetId: currentMeasure.assetId }"
            icon="more_vert"
            [items]="deleteMenuItems()"
            menuStyleClass="ces-menu-align-right" />
        </div>
      </div>
      <div>
        <p-tabs [value]="activeTab" class="mb-(--space-8)">
          <p-tablist>
            <p-tab value="info" [routerLink]="['./info']">{{ 'entities.measure.tabs.info' | transloco }}</p-tab>
            <p-tab value="formula" [routerLink]="['./formula']">{{ 'entities.measure.tabs.formula' | transloco }}</p-tab>
            <p-tab value="verification" [routerLink]="['./verification']">{{
              'entities.measure.tabs.verification' | transloco
            }}</p-tab>
            @if (showDeviceTab) {
              <p-tab value="device" [routerLink]="['./device']">{{ 'entities.measure.tabs.device' | transloco }}</p-tab>
            }
          </p-tablist>
        </p-tabs>
        <router-outlet />
      </div>
    }
  }
</div>
